import { Link } from "react-router-dom"

const PortfolioLink = () => {
    return (
       
        <Link className="portfolioLink" exact to="portfolio"><span className="line"></span> Portfolio</Link>
        
    )
}
export default PortfolioLink